import { Component, ChangeDetectionStrategy } from "@angular/core";
import {
  DataService,
  ModalService,
  NotificationService,
  SharedModule,
  TypedBaseListComponent,
} from "@bb-vendure/admin-ui/core";
import {
  PushTemplate,
  PushTemplatesDocument,
  UpdatePushTemplateDocument,
  UpdatePushTemplateInput,
} from "src/generated-gql/graphql";
import { FormatCamelCasePipe } from "../../pipe/format_carmel_case.pipe";
import { take } from "rxjs";
@Component({
  selector: "admin-push-template-list",
  templateUrl: "./list.component.html",
  standalone: true,
  imports: [SharedModule, FormatCamelCasePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class PushTemplateListComponent extends TypedBaseListComponent<
  typeof PushTemplatesDocument,
  "pushTemplates"
> {
  readonly filters = this.createFilterCollection()
    .addIdFilter()
    .addFilter({
      name: "type",
      type: { kind: "select", options: [] },
      label: "push.type",
      filterField: "type",
    })
    .connectToRoute(this.route);

  readonly sorts = this.createSortCollection()
    .defaultSort("createdAt", "DESC")
    .addSort({ name: "createdAt" })
    .addSort({ name: "updatedAt" })
    .connectToRoute(this.route);

  constructor(
    private notificationService: NotificationService,
    protected dataService: DataService,
    private modalService: ModalService,
  ) {
    super();
    super.configure({
      document: PushTemplatesDocument,
      getItems: (data) => data.pushTemplates,
      setVariables: (skip, take) => ({
        options: {
          skip,
          take,
          filter: this.filters.createFilterInput(),
          sort: this.sorts.createSortInput(),
        },
      }),
      refreshListOnChanges: [
        this.filters.valueChanges,
        this.sorts.valueChanges,
      ],
    });
  }

  onToggleActive(template: PushTemplate, isActive: boolean) {
    const activeText = "push.question-activate-template";
    const disableText = "push.question-disable-template";
    this.modalService
      .dialog({
        title: "push.template-update-active",
        body: isActive ? activeText : disableText,
        buttons: [
          {
            label: "common.yes",
            type: "primary",
            returnValue: true,
          },
          {
            label: "common.no",
            type: "secondary",
            returnValue: false,
          },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const { updatedAt, createdAt, ...newTemplate } = template;
          const input: UpdatePushTemplateInput = {
            ...newTemplate,
            isActive,
          };
          this.dataService
            .mutate(UpdatePushTemplateDocument, { input })
            .pipe(take(1))
            .subscribe(() => {
              const notifyText = isActive
                ? "push.template-activate-success"
                : "push.template-disable-success";
              this.notificationService.success(notifyText);
            });
        }
      });
  }
}
